export const fundInfoFetching = (fundInfo) => {
  const result = {
    ...fundInfo,
    isFetching: true
  };
  return result;
};

export const fundInfoData = (fundInfo, data) => {
  const result = {
    ...fundInfo,
    data: cleanColor(data),
    isFetching: false
  };
  return result;
};

export const fundInfoError = (fundInfo, error) => {
  const result = {
    ...fundInfo,
    errorMessage: error,
    isFetching: false
  };
  return result;
};

const cleanColor = (data) => {
  return {
    ...data,
    color: data.color ? data.color : '#CB2427'
  };
};

export const filterHistoricalNav = (historicalNav, data) => {
  const result = {
    ...historicalNav,
    currentPage: data.currentPage ? data.currentPage : 1,
    totalPage: data.totalPage ? data.totalPage : 1,
    items: data.items ? data.items : []
  };
  return result;
};

export const filterHistoricalNavGraph = (informationWidget, data) => {
  const result = {
    ...informationWidget,
    historicalNavGraph: data ? data : []
  };
  return result;
};

export const filterDividend = (dividend, data) => {
  const result = {
    ...dividend,
    currentPage: data.currentPage ? data.currentPage : 1,
    totalPage: data.totalPage ? data.totalPage : 1,
    items: data ? data : []
  };
  return result;
};

export const changePage = (state, page) => {
  const result = {
    ...state,
    currentPage: page !== state.currentPage ? page : state.currentPage
  };
  return result;
};

export const filterDrawdownByDate = (state, data) => {
  const result = {
    ...state,
    drawdownListByDate: data
  };
  return result;
};

export const resetDrawdownByDate = (state) => {
  const result = {
    ...state,
    drawdownListByDate: []
  };
  return result;
};

export const filterMaximumDrawdown = (state, data) => {
  const result = {
    ...state,
    maximumDrawdownList: data
  };
  return result;
};

export const resetMaximumDrawdown = (state) => {
  const result = {
    ...state,
    maximumDrawdownList: []
  };
  return result;
};

export const resetMonthlyReturn = (state) => {
  const result = {
    ...state,
    monthlyReturns: []
  };
  return result;
};

export const filterPriceRange = (state, data) => {
  let priceRangeList = [];
  if (data) {
    priceRangeList = [
      {
        time: '1 สัปดาห์',
        maxValue: data.maxOfWeek,
        minValue: data.minOfWeek,
        value: data.current
      },
      {
        time: '1 เดือน',
        maxValue: data.maxOfMonth,
        minValue: data.minOfMonth,
        value: data.current
      },
      {
        time: '3 เดือน',
        maxValue: data.maxOfThreeMonths,
        minValue: data.minOfThreeMonths,
        value: data.current
      },
      {
        time: '6 เดือน',
        maxValue: data.maxOfSixMonths,
        minValue: data.minOfSixMonths,
        value: data.current
      },
      {
        time: '1 ปี',
        maxValue: data.maxOfOneYear,
        minValue: data.minOfOneYear,
        value: data.current
      }
    ];
  }

  const result = {
    ...state,
    priceRanges: state.priceRanges !== priceRangeList ? priceRangeList : state.priceRanges
  };
  return result;
};

export const resetPriceRange = (state) => {
  const result = {
    ...state,
    priceRanges: []
  };
  return result;
};

export const filterVolatilities = (state, data) => {
  const result = {
    ...state,
    volatilities: data ? data : state.volatilities
  };
  return result;
};

export const resetVolatilities = (state) => {
  const result = {
    ...state,
    volatilities: []
  };
  return result;
};

export const filterReturnExpenseRatio = (state, data) => {
  const result = {
    ...state,
    returnExpenseRatio: data ? data : null
  };
  return result;
};

export const resetReturnExpenseRatio = (state) => {
  const result = {
    ...state,
    returnExpenseRatio: null
  };
  return result;
};

export const filterMonthlyProfit = (state, data) => {
  const result = {
    ...state,
    monthlyProfit: data ? data : null
  };
  return result;
};

export const resetMonthlyProfit = (state) => {
  const result = {
    ...state,
    monthlyProfit: null
  };
  return result;
};

export const filterReturnHistory = (state, data) => {
  const result = {
    ...state,
    returnHistory: data ? data : null
  };
  return result;
};

export const resetReturnHistory = (state) => {
  const result = {
    ...state,
    returnHistory: null
  };
  return result;
};

export const changeDrawdownSortingFilters = (state, data) => {
  const result = {
    ...state,
    currentDrawdownSortingFilters: data
  };
  return result;
};

export const changeNavGraphDate = (state, data) => {
  if (state.navGraphDateRange.startDate !== data.startDate || state.navGraphDateRange.endDate !== data.endDate) {
    return {
      ...state,
      navGraphDateRange: {
        startDate: data.startDate,
        endDate: data.endDate
      }
    };
  } else {
    return {
      ...state
    };
  }
};

export const changeSortedDrawdown = (state, data) => {
  const result = {
    ...state
  };
  return result;
};

export const setIsFetching = (state) => {
  const result = {
    ...state,
    isFetching: true
  };
  return result;
}

export const filterDataResult = (state, data) => {
  const result = {
    ...state,
    isFetching: false,
    data: data,
    errorMessage: null
  };
  return result;
}

export const resetDataResult = (state, message) => {
  const result = {
    ...state,
    isFetching: false,
    data: [],
    errorMessage: message
  };
  return result;
}

export const resetDataResultToObject = (state, message) => {
  const result = {
    ...state,
    isFetching: false,
    data: {},
    errorMessage: message
  };
  return result;
}

// Constant filter type
const filterTypeList = [
  {
    type: 'TOP_TEN_HOLDINGS',
    dateType: 'topHoldingDate',
    key: 'topHoldingDetails',
    detailName: 'holdingDetailName',
    value: 'holdingDetailWeighting'
  },
  {
    type: 'STOCKS',
    dateType: 'topHoldingDate',
    key: 'topHoldingDetails',
    detailName: 'holdingDetailName',
    value: 'holdingDetailWeighting'
  },
  {
    type: 'COUNTRY_EXPOSURE',
    dateType: 'countryExposureDate',
    key: 'countryExposureDetails',
    detailName: 'country',
    value: 'value'
  },
  {
    type: 'SECTOR_INDICES',
    dateType: 'globalSectorPortfolioDate',
    detailName: [
      'equitySectorBasicMaterialsLongRescaled',
      'equitySectorCommunicationServicesLongRescaled',
      'equitySectorConsumerCyclicalLongRescaled',
      'equitySectorConsumerDefensiveLongRescaled',
      'equitySectorEnergyLongRescaled',
      'equitySectorFinancialServicesLongRescaled',
      'equitySectorHealthcareLongRescaled',
      'equitySectorIndustrialsLongRescaled',
      'equitySectorRealEstateLongRescaled',
      'equitySectorTechnologyLongRescaled',
      'equitySectorUtilitiesLongRescaled'
    ],
    value: '',
  }
];

// Constant default color
const defaultColors = [
  '#6EA7BC',
  '#1666C3',
  '#384C78',
  '#438A5D  ',
  '#F5DF76',
  '#DFB621',
  '#CC5F06',
  '#874B4B',
  '#8A2224',
  '#CB2427',
  '#0A73EA',
  '#3190FB',
  '#77B2F5',
  '#8CBC5B',
  '#699953',
  '#C9C709',
  '#B569F7',
  '#D5A1DB',
  '#F0888A',
  '#E7581A',
  '#ECC405',
  '#EEB0B1',
  '#6B5948',
  '#688037',
  '#A2B8AB'
];

export const convertDataToPortChart = (dataObj, filterType) => {
  let summary = 0;
  let colors = dataObj.colors && dataObj.colors.lenght > 0 ? dataObj.colors : defaultColors;
  let product = filterTypeList.find(obj => obj.type === filterType);
  let categoryList = [];
  let returnFormatData = { summary: 0, date: '', categoryList: [] }

  if (product.type === 'SECTOR_INDICES') {
    let list = product.detailName;

    if (dataObj) {
      // Push obj to List
      for (let i = 0; i < list.length; i++) {
        categoryList.push({
          category: dataObj[list[i]+'Name'] ? dataObj[list[i]+'Name'] : '-',
          value: dataObj[list[i]] ? dataObj[list[i]].toFixed(2) : '0',
        });
      }

      returnFormatData.date = dataObj[product.dateType];
    }
  } else {
    let data = dataObj[product.key];
    if (data) {
      // Push obj to List
      categoryList = data.map(obj => ({
        category : obj[product.detailName] ? obj[product.detailName] : '-',
        value : obj[product.value] ? obj[product.value].toFixed(2) : '0'
      }));

      returnFormatData.date = dataObj[product.dateType];
    }

    //   // else if (count === 11 && summary != 100) {
    //   //   productLists.productList.push({
    //   //     category : 'Others',
    //   //     value : formatNumber(100 - summary),
    //   //     color : defaultColors[count],
    //   //   })
    //   //   summary = 100;
    //   // }

    //   // else {
    //   //   break;
    //   // }
  }

  // Sorting large to small value.
  categoryList.sort((a, b) => b.value - a.value);

  // Summary percentage Item list
  summary = categoryList.reduce((prev, cur) => prev + parseFloat(cur.value), 0);

  // Insert Color
  categoryList.forEach((obj, index) => obj['color'] = colors[index]);

  if (categoryList.length > 0) {
    returnFormatData.summary = summary;
    returnFormatData.categoryList = categoryList;
  } else {
    returnFormatData = {
      summary: 0,
      categoryList: [{ category: 'No Data', value: 100, color: colors[0] }],
      date: ''
    };
  }

  return returnFormatData;
};

export const refactorData = (data, axisX, axisY) => {
  axisX = axisX ? axisX : 'time';
  axisY = axisY ? axisY : 'value';

  let list= [];
  if (data && data.length > 0) {
    data.map((obj, index) => {
      list.push({
        time: obj[axisY],
        value: obj[axisX]
      })
    })
  }

  return list;
}

export const handleRedirectPage = (e, item, attr= 'id') => {
  if (!item[attr] ) {
    e.preventDefault();
  }
  return;
}

export const accountStatus = {
  'Y': {
    color: 'success',
    status: 'Yes',
  },
  'N': {
    color: 'danger',
    status: 'No',
  },
}